import React from "react";
import "./EarningCards.css";
import { FaDollarSign, FaPuzzlePiece } from "react-icons/fa";

export default function EarningCards({ total, solved }) {
  return (
    <div className="earning-cards">

      <div className="earning-card">
        <div className="icon-box green">
          <FaDollarSign size={22} />
        </div>
        <div className="details">
          <h4>Total Earnings</h4>
          <span>${total.toFixed(2)}</span>
        </div>
      </div>

      <div className="earning-card">
        <div className="icon-box blue">
          <FaPuzzlePiece size={22} />
        </div>
        <div className="details">
          <h4>Puzzles Solved</h4>
          <span>{solved}</span>
        </div>
      </div>

    </div>
  );
}
